var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-tile',{attrs:{"to":_vm.link},on:{"click":_vm.closeCreateDocument}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"list-title"},[_vm._v(_vm._s(_vm.label)+" "),(_vm.restriction || _vm.hasRestriction
                    )?_c('span',{staticClass:"dev-label"},[_vm._v("DEV")]):_vm._e()])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }